import {FilePondFile} from 'filepond';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import React, {useState} from 'react';
import {FilePond, registerPlugin} from 'react-filepond';

import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond/dist/filepond.min.css';

registerPlugin(FilePondPluginImagePreview, FilePondPluginImageExifOrientation);

// Register the plugin
registerPlugin(FilePondPluginImagePreview);

interface imageUploadModalPropsT {
  isVisible: boolean;
  onClose?: () => void;
  onSubmit: (files: File[]) => void;
  title: string;
  maxFiles?: number;
  allowMultiple?: boolean;
  files?: File[];
  setFiles?: (files: File[]) => void;
}

export const ImageUploadModalComponent: React.FC<imageUploadModalPropsT> = ({
  isVisible,
  onClose,
  onSubmit,
  title,
  maxFiles = 6,
  allowMultiple = true,
  files: initialFiles = [],
  setFiles: setFilesProp,
}) => {
  const [files, setFiles] = useState<File[]>(initialFiles);

  const handleFilesUpdate = (fileItems: FilePondFile[]) => {
    const updatedFiles = fileItems.map(fileItem => fileItem.file) as File[];
    setFiles(updatedFiles);
    if (setFilesProp) {
      setFilesProp(updatedFiles);
    }
  };

  const handleSubmit = () => {
    onSubmit(files);
    setFiles([]);
  };

  return (
    <div
      className={`hs-overlay ${isVisible ? 'flex' : 'hidden'} ti-modal fixed inset-0 items-center justify-center bg-black bg-opacity-30`}
    >
      <div className="ti-modal-box modal-dialog-centered mt-0 max-h-[80vh] w-full overflow-scroll !opacity-100 ease-out hs-overlay-open:mt-7 sm:w-1/2 md:w-1/3 lg:w-1/4">
        <div className="ti-modal-content flex h-full flex-col rounded-lg bg-white shadow-lg">
          <div className="ti-modal-header flex-shrink-0 border-b p-4">
            <h6 className="modal-title !text-default text-[1rem] font-semibold dark:text-defaulttextcolor/70">
              {title}
            </h6>
            <button type="button" className="hs-dropdown-toggle !text-[1rem] !font-semibold" onClick={onClose}>
              <span className="sr-only">Close</span>
              <i className="ri-close-line"></i>
            </button>
          </div>
          <div className="ti-modal-body px-6 py-4">
            <div className="product-documents-container">
              <p className="mb-2 text-[0.875rem] font-semibold">Product Images:</p>
              <FilePond
                className="product-Images w-full"
                files={files}
                onupdatefiles={handleFilesUpdate}
                allowMultiple={allowMultiple}
                maxFiles={maxFiles}
                name="files"
                labelIdle="Drag & Drop your files here or click to browse"
              />
            </div>
          </div>
          <div className="ti-modal-footer flex flex-shrink-0 justify-end border-t p-4">
            <button type="button" className="ti-btn bg-primary !font-medium text-white" onClick={handleSubmit}>
              Upload
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
